import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getSeatmapByShortCode } from '../utilities/api'
import useSeatmapStore from '../stores/seatmapStore'

/**
 * Loads seatmap mapping + background into seatmapStore for the current event route.
 */
export default function useSeatmapBootstrap() {
  const { shortcode, slug } = useParams()
  const setData = useSeatmapStore((state) => state.setData)
  const setBackground = useSeatmapStore((state) => state.setBackground)
  const setSeatBorderRadius = useSeatmapStore(
    (state) => state.setSeatBorderRadius
  )
  const setSeatmapId = useSeatmapStore((state) => state.setSeatmapId)
  const setMaxScale = useSeatmapStore((state) => state.setMaxScale)
  const background = useSeatmapStore((state) => state.background)

  useEffect(() => {
    let cancelled = false

    const loadMap = async () => {
      try {
        const seatmapRes = await getSeatmapByShortCode(shortcode, slug)
        if (cancelled || seatmapRes.status !== 200) return
        const seatmap = seatmapRes.data
        setData(seatmap?.mapping)
        setBackground(seatmap?.background)
        if (seatmap?.id != null) setSeatmapId(seatmap.id)
        if (seatmap?.seat_border_radius) {
          setSeatBorderRadius(seatmap.seat_border_radius)
        }
        if (seatmap?.max_scale) setMaxScale(seatmap.max_scale)
      } catch {
        /* seatmap optional */
      }
    }

    loadMap()
    return () => {
      cancelled = true
    }
  }, [
    shortcode,
    slug,
    setData,
    setBackground,
    setSeatmapId,
    setSeatBorderRadius,
    setMaxScale,
  ])

  return {
    hasMap: Boolean(background?.url),
    background,
  }
}
